import { BILLING_PERIOD_STATUSES, type BillingPeriodStatus } from '@/shared/api/billing';
import { isIsoDay } from '@/shared/format';

/**
 * "Sin archivar" in the filter of the state (`AM-368`): not a state of its own but every period that
 * has not been archived (`closed`), whatever step of the close it is in. It is what "Períodos abiertos"
 * of the board "Facturación" counts, so its "Ver todo" opens the list on it. The server takes it as
 * `status[in]` with the other five states.
 */
export const UNARCHIVED = 'unarchived';

/** The states "Sin archivar" stands for: all of them but `closed`. */
export const UNARCHIVED_STATUSES: readonly BillingPeriodStatus[] = BILLING_PERIOD_STATUSES.filter(
  (status) => status !== 'closed',
);

export type PeriodStatusFilter = BillingPeriodStatus | typeof UNARCHIVED;

/**
 * `validateSearch` of `/billing/periods` (`AM-368`): every filter lives in the URL, as in Facturas and
 * Contratos (`AM-350`), so a link opens the list already narrowed ("Ver todo" of "Períodos abiertos")
 * and back and forward keep what the reader chose. `endedBy` is the last day a window may end on, which
 * "Ver cuáles" of the notice of the months already over sets. A value the list does not know is dropped,
 * never thrown on.
 */
export interface PeriodsSearch {
  status?: PeriodStatusFilter;
  endedBy?: string;
}

export function periodsSearchSchema(search: Record<string, unknown>): PeriodsSearch {
  const result: PeriodsSearch = {};

  const status = search['status'];
  if (
    typeof status === 'string' &&
    (status === UNARCHIVED || BILLING_PERIOD_STATUSES.includes(status as BillingPeriodStatus))
  ) {
    result.status = status as PeriodStatusFilter;
  }

  const endedBy = search['endedBy'];
  if (isIsoDay(endedBy)) {
    result.endedBy = endedBy;
  }

  return result;
}
